<main class="bg-white position-relative">
  <!-- search bar -->
  <div class="container">
    <div class="faq-sec padd-top-bot">
      <div class="col-md-8 offset-md-2">
        <h2 class="page-heading">Frequently asked questions</h2>
        <div class="faq-body">
          <div class="accordian-info accordion" id="section1">
            <div class="faq-title"><i class="flaticon-plus"></i>Where is my order?</div>
            <div class="accordian-body accordion-bg">
              <div class="faq">
                <p>All in-stock, non-preorders will be filled within 7-10 business days of being
                  placed (not including weekends or holidays).</p>
                <p>Orders are packed and shipped in Conyers, GA. Shipments are made via trackable
                  service. You will receive an email with tracking information as soon as your
                  order is headed your way. </p>
                <p>Please allow 1 day for tracking information to update on your order.</p>
              </div>
            </div>
          </div>
          <div class="accordian-info accordion" id="section2">
            <div class="faq-title"><i class="flaticon-plus"></i>Where is my order?</div>
            <div class="accordian-body accordion-bg">
              <div class="faq">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porttitor
                  egestas orci, vitae ullamcorper risus consectetur id. Donec at velit vestibulum,
                  rutrum massa quis, porttitor lorem. Donec et ultricies arcu. In odio augue,
                  hendrerit nec nisl ac, rhoncus gravida mauris. </p>
              </div>
            </div>
          </div>
          <div class="accordian-info accordion" id="section3">
            <div class="faq-title"><i class="flaticon-plus"></i>Where is my order?</div>
            <div class="accordian-body accordion-bg">
              <div class="faq">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porttitor
                  egestas orci, vitae ullamcorper risus consectetur id. Donec at velit vestibulum,
                  rutrum massa quis, porttitor lorem. Donec et ultricies arcu. In odio augue,
                  hendrerit nec nisl ac, rhoncus gravida mauris. </p>
              </div>
            </div>
          </div>
          <div class="accordian-info accordion" id="section4">
            <div class="faq-title"><i class="flaticon-plus"></i>Where is my order?</div>
            <div class="accordian-body accordion-bg">
              <div class="faq">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porttitor
                  egestas orci, vitae ullamcorper risus consectetur id. Donec at velit vestibulum,
                  rutrum massa quis, porttitor lorem. Donec et ultricies arcu. In odio augue,
                  hendrerit nec nisl ac, rhoncus gravida mauris. </p>
              </div>
            </div>
          </div>
          <div class="accordian-info accordion" id="section5">
            <div class="faq-title"><i class="flaticon-plus"></i>Where is my order?</div>
            <div class="accordian-body accordion-bg">
              <div class="faq">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum porttitor
                  egestas orci, vitae ullamcorper risus consectetur id. Donec at velit vestibulum,
                  rutrum massa quis, porttitor lorem. Donec et ultricies arcu. In odio augue,
                  hendrerit nec nisl ac, rhoncus gravida mauris. </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- top_selling_sec -->
</main>
